module.exports = __webpack_public_path__ + "static/media/corona-01.51c1d3ff.jpg";